import React from 'react';
import config from '../../config';

export default function Footer() {
  return (
    <footer className="bg-dark py-5 text-white-75">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4 mb-lg-0">
            <h3 className="text-white h6 mb-3">Wasescha Maler</h3>
            <address className="mb-0" style={{ lineHeight: 1.8 }}>
              Ricardo Wasescha<br />
              Gravas 6<br />
              7452 Cunter<br />
              Val Surses, Graubünden, Schweiz
            </address>
          </div>
          <div className="col-lg-4 mb-4 mb-lg-0">
            <h3 className="text-white h6 mb-3">Kontakt</h3>
            <p className="mb-1">
              <i className="fas fa-phone mr-2"></i>
              <a href="tel:+41815589899" className="text-white-75">
                +41 (0) 81 558 98 99
              </a>
            </p>
            <p className="mb-1">
              <i className="fas fa-mobile-alt mr-2"></i>
              <a href="tel:+41792637706" className="text-white-75">
                +41 (0) 79 263 77 06
              </a>
            </p>
            <p className="mb-0">
              <i className="fas fa-envelope mr-2"></i>
              <a href={`mailto:${config.email}`} className="text-white-75">
                {config.email}
              </a>
            </p>
          </div>
          <div className="col-lg-4 mb-4 mb-lg-0">
            <h3 className="text-white h6 mb-3">Links</h3>
            <p className="mb-1">
              <a href="/#services" className="text-white-75">
                Angebot
              </a>
            </p>
            <p className="mb-1">
              <a href="/über-mich" className="text-white-75">
                Über mich
              </a>
            </p>
            <p className="mb-0">
              <a href="/#contact" className="text-white-75">
                Kontakt
              </a>
            </p>
          </div>
        </div>
        <hr className="my-4" style={{ borderColor: 'rgba(255,255,255,0.1)' }} />
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-left small">
            Copyright &copy; {new Date().getFullYear()} Wasescha Maler – Alle Rechte vorbehalten
          </div>
          <div className="col-md-6 text-center text-md-right small">
            Malerbetrieb im Val Surses, Graubünden
          </div>
        </div>
      </div>
    </footer>
  );
}